export enum HttpHeader {
  CONTENT_TYPE = 'content-type',
  AUTHORIZATION = 'authorization'
}
